import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { TranslateService } from "@ngx-translate/core";
import { UiService } from "app/helper-components/UiService";
import { BARACK_NAMES, Constants } from "app/helpers/Constants";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { UserDataService } from "app/helpers/user-data.service";
import { ImageSliderComponent } from "app/main/image-slider/image-slider.component";
import { environment } from "environments/environment";
import { EventsService } from "../../events.service";

@Component({
  selector: "event-normal-card",
  templateUrl: "./event-normal-card.component.html",
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class EventNormalCardComponent implements OnInit, AfterViewInit {
  parameters: any = {};
  rights: any = [];
  @Input() event: any = {};

  MAADHANTHIRA_SANDHA = Constants.MAADHANTHIRA_SANDHA;
  POTHU_VARAVU_SELAVU = Constants.POTHU_VARAVU_SELAVU;
  PORUPALAR_NIYAMANA_THEERMANAM = Constants.PORUPALAR_NIYAMANA_THEERMANAM;
  THOGUTHI_KALANTHAIVU = Constants.THOGUTHI_KALANTHAIVU;
  barracks = BARACK_NAMES;
  // API_FILES = environment.API_FILES;
  API_FILES = environment.API_GET_MEDIA_EVENT;

  dialogRef: any;

  constructor(
    private _matDialog: MatDialog,
    private _eventsService: EventsService,
    private _activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private router: Router,
    private translate: TranslateService,
    private uiService: UiService,
    private postService: PostService,
    private snackBar: MatSnackBar,
    private userDataService: UserDataService,
    private bottomSheet: MatBottomSheet,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe((data) => {
      this.parameters = this.helper.getParameters(data["_v"]);
    });

    this.rights =
      this.userDataService.userData.rights[this.parameters.party_post_id];
  }

  ngAfterViewInit(): void {}

  zoomImage(file: any) {
    var images = file.event_files.map((val) => {
      return (
        this.API_FILES + "?dir=eventFiles/" + file.event_id + "&name=" + val
      );
    });

    this.dialogRef = this._matDialog.open(ImageSliderComponent, {
      panelClass: "event-form-dialog",
      data: images,
    });
    this.dialogRef.afterClosed();
  }

  isImage(file: string) {
    var isValidFileExtension = [".jpg", ".jpeg", ".gif", ".bmp", ".png"];
    var status = false;
    isValidFileExtension.forEach((val) => {
      if (file.toLowerCase().endsWith(val)) {
        status = true;
      }
    });

    return status;
  }

  errorHandler(event) {
    event.target.src = "/assets/images/empty_profile_male.jpg";
  }

  tamiltype() {
    window.open("http://www.tamiltyping.in/", "_blank");
  }
}
